<footer>
  <div class="content-wrapper">
    <div class="float-left">
      <span class="version">Weld Manager - v{{ version }}</span>
      <p>&copy; {{ currentYear }} Chevron Corporation. All rights reserved.</p>
    </div>
  </div>
</footer>

